<template>
  <SysDirCommon :dir-name="'物品分类'" :dir-def-id="'oa_supplier'" :query-id="'oa_material'"></SysDirCommon>
</template>

<script>
import SysDirCommon from "@/views/applications/sys/SysDirCommon.vue";
export default {
  name: "MaterialCatalog",
  components: {SysDirCommon},
  data() {
    return {}
  },
  methods: {},
  created() {}
}
</script>

<style lang="less" scoped>
@import 'src/global';

</style>